<template>
  <div class="vx-card mol-card-interaction">
    <vs-row class="card-content">
      <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
        <span class="aisea-text-16-600-white truncate">
          {{ label }}
        </span>
      </vs-col>
    </vs-row>
    <ul>
      <li>
        <vs-row class="card-content">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> 計画数量（割増） </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ plannedQuantity }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="card-content">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> 投入実績 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ inputAmount }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="card-content">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> 残投入量（割増） </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ remainInputAmount }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="card-content">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> 更新日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ updateTime }}
            </span>
          </vs-col>
        </vs-row>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 投入実績カードの一つを描画するコンポーネント
 * @parent O.VesselEquipmentBaseStations
 * @parent O.EquipmentBaseStation
 * @props equipmentType: 投入実績カードの情報
 */
import moment from "moment";
export default {
  name: "M.EquipmentTypesCard",
  props: {
    equipmentType: {
      type: Object,
    },
  },
  data() {
    return {
      defaultValues: {
        noneText: "",
        noneData: "-",
        noneDate: "---",
      },
    };
  },
  computed: {
    // 資機材
    label() {
      if (!this.equipmentType) return this.defaultValues.noneText;
      return this.equipmentType.label
        ? this.equipmentType.label
        : this.defaultValues.noneText;
    },
    // 計画数量（割増）
    plannedQuantity() {
      if (!this.equipmentType || !this.equipmentType.data)
        return this.defaultValues.noneData;
      return this.equipmentType.data.planned_quantity != null
        ? `${this.equipmentType.data.planned_quantity.toLocaleString()}${
            this.unit
          }`
        : this.defaultValues.noneData;
    },
    // 投入実績
    inputAmount() {
      if (!this.equipmentType || !this.equipmentType.data)
        return this.defaultValues.noneData;
      return this.equipmentType.data.input_amount != null
        ? `${this.equipmentType.data.input_amount.toLocaleString()}${this.unit}`
        : this.defaultValues.noneData;
    },
    // 残投入量（割増）
    remainInputAmount() {
      if (!this.equipmentType || !this.equipmentType.data)
        return this.defaultValues.noneData;
      return this.equipmentType.data.remain_input_amount != null
        ? `${this.equipmentType.data.remain_input_amount.toLocaleString()}${
            this.unit
          }`
        : this.defaultValues.noneData;
    },
    // 表示する単位
    unit() {
      if (!this.equipmentType.unit) return this.defaultValues.noneText;
      if (this.equipmentType.unit === "m3") return "㎥";
      return this.equipmentType.unit;
    },
    // 更新日時
    updateTime() {
      if (!this.equipmentType) return this.defaultValues.noneDate;
      if (!this.equipmentType.data) return this.defaultValues.noneDate;
      if (!this.equipmentType.data.timestamp)
        return this.defaultValues.noneDate;
      if (!this.equipmentType.data.timestamp.seconds)
        return this.defaultValues.noneDate;
      return moment(this.equipmentType.data.timestamp.seconds * 1000).format(
        "YYYY/MM/DD HH:mm",
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.vx-card {
  background: $aisea-blue-gray;
  width: 360px;
  height: 145px;
  padding: 16px;
  margin: 0 auto;

  .card-content {
    margin-bottom: 6px;
  }
}
</style>
